$('#gform_conditional_logic-js').attr('data-cookieconsent', 'ignore');
$('#gform_conditional_logic-js-extra').attr('data-cookieconsent', 'ignore');
$('#gform_json-js').attr('data-cookieconsent', 'ignore');
$('#gform_gravityforms-js-extra').attr('data-cookieconsent', 'ignore');
$('#gform_gravityforms-js').attr('data-cookieconsent', 'ignore');
$('#gforms_recaptcha_recaptcha-js-extra').attr('data-cookieconsent', 'ignore');
$('#gforms_recaptcha_recaptcha-js').attr('data-cookieconsent', 'ignore');
$('#gforms_recaptcha_recaptcha-js-after').attr('data-cookieconsent', 'ignore');
$('#gfsupercharge_embed-js-extra').attr('data-cookieconsent', 'ignore');
$('#gfsupercharge_embed-js').attr('data-cookieconsent', 'ignore');
$('#gfsupercharge_embed-js-after').attr('data-cookieconsent', 'ignore');
$('#gform_recaptcha-js').attr('data-cookieconsent', 'ignore');

$(document).ready(function () {
    $('#gform_recaptcha-js').attr('data-cookieconsent', 'ignore');
    $('.ginput_container_select').on('change', 'select', function () {
        if (this.value) {
            $(this).addClass('active');
        } else {
            $(this).removeClass('active');
        }
    });

    $('a.open--form').click(function () {
        var mulde = $(this).prev().prev().text();
        sessionStorage.setItem('mulde', mulde);
    });
});
